// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1448":"8a9877aa","3060":"c2bbc28e","5350":"238d3414","5768":"61378a2b","9025":"7eec3253"}[chunkId] + ".chunk.css";
};